import React, { useState, useEffect } from 'react';

import PresentationWidget from './presentation-widget';

import PrimusMoneyDidWidgetService from '../model/did-widget-service.js';

const IssuerView = ({root, params}) => {
	const [build_version, setBuildVersion] = useState('unknown');

	const [did_widget_params, setWidgetParams] = useState({
		description: "issuer did widget specification",
		widget: "connect"
	});

	const [remote_config, setRemoteConfig] = useState(null);

	const [remote_widget_params_endpoint, setRemoteWidgetParamsEndpoint] = useState(null);

	const [widget_client_id, setWidgetClientId] = useState(null);

	const [flow_type, setFlowType] = useState(null);

	const [flow_type_list, setFlowTypeList] = useState([]);
	const [show_flow_type_list, setShowFlowTypeList] = useState(false);


	const [last_change_on, setLastChangeOn] = useState(Date.now());

	const [loaded, setIsLoaded] = useState(false);

	const _loadComponent = async () => {
		try {

			const URL = require("url");
			let url = window.location.href;
			url = url.replace('#/', '/');
			let {query} = URL.parse(url, true);

			let _flow_type = query.flow_type;

			if (_flow_type)
			setFlowType(_flow_type);

			// see if there is a remote overload
			let _remote_conf;
			if (params && params.config && params.config.remote_config_endpoint) {
				_remote_conf = await root.fetchJson(params.config.remote_config_endpoint);

				if (_remote_conf)
				setRemoteConfig(_remote_conf);
			}

			// set widget params in component
			let _did_widget_params = Object.assign({}, params.widget_params);

			// see if there is a remote overload
			if (_remote_conf) {
				let widget_params_endpoint = (_remote_conf.card_issuer_page ? _remote_conf.card_issuer_page + '/widget' : null);

				if (!_flow_type && _remote_conf.default_flow_type) {
					_flow_type = _remote_conf.default_flow_type

					setFlowType(_flow_type);
				}

				if (_remote_conf.flow_type_list) {
					// fill flow type list
					let _flow_type_list = [];

					let keys = Object.keys(_remote_conf.flow_type_list);

					for (var i = 0; i < keys.length; i++) {
						let flow_type_details = _remote_conf.flow_type_list[keys[i]]
						let item = {uuid: keys[i]};

						item.description = (flow_type_details.description ? flow_type_details.description : keys[i]);

						_flow_type_list.push(item);
					}

					setFlowTypeList(_flow_type_list);
				
					// find corresponding widget_params_endpoint
					if (_remote_conf.flow_type_list && _remote_conf.flow_type_list[_flow_type]) {
						let flow = _remote_conf.flow_type_list[_flow_type].flow;
						let type = _remote_conf.flow_type_list[_flow_type].version;

						if (_remote_conf.flow_types && _remote_conf.flow_types[flow] && _remote_conf.flow_types[flow][type])
						widget_params_endpoint = _remote_conf.flow_types[flow][type].widget_url;
					}
				}


				setRemoteWidgetParamsEndpoint(widget_params_endpoint);	
			}

			// wiget
			setWidgetParams(_did_widget_params);
			setLastChangeOn( Date.now()); // will change key of MyDidWidget to force remounting

			setBuildVersion(params.build_version);

			const _widget_uuid = PrimusMoneyDidWidgetService.guid();
			const _widget_client_id = 'MyDidWidgetClient-' + _widget_uuid;
			console.log('setting widget_client_id to ' + _widget_client_id + ' old id is  ' + widget_client_id);
			setWidgetClientId(_widget_client_id);

			// show flow type select
			let _show = (_remote_conf && (_remote_conf.show_flow_type_select === true) ? true : (query.show_list == "1" ? true : false));

			setShowFlowTypeList(_show);

			setIsLoaded(true);

		}
		catch(e) {
			console.log('exception in IssuerView._loadComponent: ' + e);
		}
	};


	// componentDidMount
	useEffect(() => {
		_loadComponent().catch(err => {});
	}, []); // end of useEffect

	// user actions
	const onSelectFlowType = async (uuid)  => {
		let _flow_type = uuid;
		
		setFlowType(_flow_type);

		let _remote_conf = remote_config;

		if (_remote_conf && _remote_conf.flow_type_list && _remote_conf.flow_type_list && _remote_conf.flow_type_list[_flow_type]) {
				let widget_params_endpoint;

				let flow = _remote_conf.flow_type_list[_flow_type].flow;
				let type = _remote_conf.flow_type_list[_flow_type].version;

				if (_remote_conf.flow_types && _remote_conf.flow_types[flow] && _remote_conf.flow_types[flow][type]) {

					widget_params_endpoint = _remote_conf.flow_types[flow][type].widget_url;
					setRemoteWidgetParamsEndpoint(widget_params_endpoint);	
				}
		}

		// trigger refresh of PresentationWidget
		setLastChangeOn(Date.now());
	};


	return (
		<div className="Pane">
		<h1>Issuing your Patronymus card</h1>

		<div className="Instructions">
			<div>You will retrieve a card in our progressive wallet app<br />after having presented a PID from a EUDI Wallet by:</div>
			<ul>
				<li>Either scanning the QR Code with your mobile to store the card in your mobile browser</li>
				<li>Or clicking on the QR Code to store the card in the current browser</li>
			</ul>
		</div>
		{(loaded === false ? 
		<></> :
		<PresentationWidget 
			widget_client_id={widget_client_id}
			did_widget_params = {did_widget_params}
			remote_widget_params_endpoint = {remote_widget_params_endpoint}
			lastchangeon = {last_change_on}
			key = {widget_client_id}
		/>)}

		{(show_flow_type_list ?
			<select
			id="input-dropdown-addon"
			className="SelectFlowType"
			title="pick a flow"
			onChange={e => onSelectFlowType(e.target.value)}
			value={flow_type}
			>
				{flow_type_list.map((item, index) => (
					<option key={item.uuid} eventKey={item.uuid} value={item.uuid}>{item.description}</option>
				))}
			</select> :
			<></>
		)}

		<div className="Contacts">
			<div>You can freely issue your own cards on <a href="https://dashboard-demo.patronymus.com">https://dashboard-demo.patronymus.com</a></div>
			<div>If you have any question, contact us at <a href="mailto:contact@patronymus.com">contact@patronymus.com</a></div>
		</div>

		</div>

	);
};
  

export default IssuerView;